
import { Component, Signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatDividerModule } from '@angular/material/divider';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageCode } from 'app/statics/language-config';
import { LanguageService } from 'app/services/language.service';

@Component({
    selector: 'app-footer',
    imports: [
    MatToolbarModule,
    MatIconModule,
    MatDividerModule,
    TranslateModule
],
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.scss'
})
export class FooterComponent {
  currentYear: number = new Date().getFullYear();
  selectedLanguage: Signal<LanguageCode>;

  constructor(private _languageService: LanguageService) {
    this.selectedLanguage = this._languageService.getCurrentLanguage();
  }
}
